import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
	registerTimesBatch
} from '../actions/index';

import '../css/App.css';

import {
	Glyphicon,
	ProgressBar,
	Button
} from '../../node_modules/react-bootstrap/lib/';

import {
	Pedestrismo,
	PedestrismoBackup
} from '../constants/enums';


const MAX_SIMULATION_SECONDS = 60;

const MAX_START_WINDOW_SECONDS = 30;

const MIN_RACE_TIME_SECONDS = 3;

const SIMULATION_INTERVAL_MS = 250;


class ParticipantRegisterSimulation extends Component {

	constructor(props) {
		super(props);

		this.state = {

			running: false,

			progress: 0,

			elapsedSeconds: 0,

			totalAthletes: 0,

			registeredAthletes: 0,

			simulationAthletes: [],

			/*
			 * Indica si la corrida actual
			 * reemplaza tiempos existentes.
			 */
			replaceExisting: false
		};


		this.simulationInterval = null;

		this.simulationStartedAt = null;

		this.lastProcessedSecond = -1;


		this.handleSimulation =
			this.handleSimulation.bind(this);

		this.checkSimulation =
			this.checkSimulation.bind(this);

		this.stopSimulation =
			this.stopSimulation.bind(this);

		this.stopSimulationInterval =
			this.stopSimulationInterval.bind(this);

		this.usesCategoryStartOffsets =
			this.usesCategoryStartOffsets.bind(this);

		this.getDistanceConfigs =
			this.getDistanceConfigs.bind(this);

		this.getParticipantDistanceConfig =
			this.getParticipantDistanceConfig.bind(this);

		this.getSimulationStartSeconds =
			this.getSimulationStartSeconds.bind(this);

		this.generateFinishSeconds =
			this.generateFinishSeconds.bind(this);

		this.getParticipantIndex =
			this.getParticipantIndex.bind(this);

		this.formatSeconds =
			this.formatSeconds.bind(this);
	}


	componentWillUnmount() {

		this.stopSimulationInterval();
	}


	stopSimulationInterval() {

		if (
			this.simulationInterval
		) {

			clearInterval(
				this.simulationInterval
			);

			this.simulationInterval = null;
		}
	}


	/*
	 * -------------------------------------------------------
	 * TIPO DE CONFIGURACION DE LARGADA
	 * -------------------------------------------------------
	 *
	 * Pedestrismo:
	 * largadas por distancia.
	 *
	 * Triatlón / Duatlón / Rural Bike-MTB:
	 * largadas por categoría.
	 */
	usesCategoryStartOffsets() {

		const competition =
			Number(
				this.props.competition || 0
			);


		return (
			competition !== 0
			&&
			competition !==
				Number(
					Pedestrismo
				)
			&&
			competition !==
				Number(
					PedestrismoBackup
				)
		);
	}


	/*
	 * -------------------------------------------------------
	 * CONFIGURACION DE LARGADAS
	 * -------------------------------------------------------
	 *
	 * Conservamos el nombre getDistanceConfigs
	 * para modificar lo mínimo posible del
	 * componente existente.
	 *
	 * PEDESTRISMO:
	 *
	 *     participant.distance
	 *
	 * TRIATLON / DUATLON / MTB:
	 *
	 *     participant.catCod
	 */
	getDistanceConfigs() {

		/*
		 * ===================================================
		 * LARGADAS POR CATEGORIA
		 * ===================================================
		 */
		if (
			this.usesCategoryStartOffsets()
		) {

			const configuredOffsets =
				Array.isArray(
					this.props.categoryStartOffsets
				)
					? this.props.categoryStartOffsets
					: [];


			let configs =
				configuredOffsets

					.filter(
						(config) => {

							return (
								String(
									config.catCod || ''
								).trim() !== ''
							);
						}
					)

					.map(
						(config, index) => {

							return {

								slot:
									index + 1,

								type:
									'category',

								catCod:
									String(
										config.catCod || ''
									).trim(),

								catName:
									String(
										config.catName ||
										config.catCod ||
										''
									).trim(),

								offset:
									Number(
										config.offset || 0
									)
							};
						}
					);


			/*
			 * Si todavía no llegaron configuraciones
			 * desde RaceConfigForm, generamos una
			 * configuración con offset 0 por cada
			 * catCod existente.
			 *
			 * De esta manera la simulación sigue
			 * funcionando y todos largan en T0.
			 */
			if (
				configs.length === 0
			) {

				const categoriesMap =
					new Map();


				(
					this.props.participantList ||
					[]
				)
					.forEach(
						(participant) => {

							const catCod =
								String(
									participant.catCod || ''
								).trim();


							const catName =
								String(
									participant.catName ||
									catCod
								).trim();


							if (
								catCod === ''
							) {

								return;
							}


							if (
								!categoriesMap.has(
									catCod
								)
							) {

								categoriesMap.set(
									catCod,
									{
										catCod,
										catName
									}
								);
							}
						}
					);


				configs =
					Array.from(
						categoriesMap.values()
					)
						.map(
							(category, index) => {

								return {

									slot:
										index + 1,

									type:
										'category',

									catCod:
										category.catCod,

									catName:
										category.catName,

									offset:
										0
								};
							}
						);
			}


			configs.sort(
				(a, b) => {

					if (
						a.offset !== b.offset
					) {

						return (
							a.offset -
							b.offset
						);
					}


					return String(
						a.catCod
					).localeCompare(
						String(
							b.catCod
						),
						'es',
						{
							numeric: true,
							sensitivity: 'base'
						}
					);
				}
			);


			return configs;
		}


		/*
		 * ===================================================
		 * PEDESTRISMO
		 * ===================================================
		 */
		const configs = [
			{
				slot: 1,

				type:
					'distance',

				distance:
					String(
						this.props.distance1Type || ''
					).trim(),

				offset:
					Number(
						this.props.distance1StartOffset || 0
					)
			},

			{
				slot: 2,

				type:
					'distance',

				distance:
					String(
						this.props.distance2Type || ''
					).trim(),

				offset:
					Number(
						this.props.distance2StartOffset || 0
					)
			},

			{
				slot: 3,

				type:
					'distance',

				distance:
					String(
						this.props.distance3Type || ''
					).trim(),

				offset:
					Number(
						this.props.distance3StartOffset || 0
					)
			}
		]
			.filter(
				(config) =>
					config.distance !== ''
			);


		configs.sort(
			(a, b) => {

				if (
					a.offset !== b.offset
				) {

					return (
						a.offset -
						b.offset
					);
				}


				return (
					a.slot -
					b.slot
				);
			}
		);


		return configs;
	}


	/*
	 * -------------------------------------------------------
	 * CONFIGURACION DEL PARTICIPANTE
	 * -------------------------------------------------------
	 *
	 * Pedestrismo:
	 *
	 *     participant.distance
	 *
	 * Otras competencias:
	 *
	 *     participant.catCod
	 */
	getParticipantDistanceConfig(
		participant,
		distanceConfigs
	) {

		if (
			!participant
		) {

			return null;
		}


		if (
			!distanceConfigs ||
			distanceConfigs.length === 0
		) {

			return null;
		}


		/*
		 * ===================================================
		 * TRIATLON / DUATLON / RURAL BIKE-MTB
		 * ===================================================
		 */
		if (
			this.usesCategoryStartOffsets()
		) {

			const participantCatCod =
				String(
					participant.catCod || ''
				).trim();


			if (
				participantCatCod === ''
			) {

				return null;
			}


			return (
				distanceConfigs.find(
					(config) => {

						return (
							String(
								config.catCod || ''
							).trim() ===
							participantCatCod
						);
					}
				)
				||
				null
			);
		}


		/*
		 * ===================================================
		 * PEDESTRISMO
		 * ===================================================
		 */
		const participantDistance =
			String(
				participant.distance || ''
			).trim();


		return (
			distanceConfigs.find(
				(config) =>
					config.distance ===
						participantDistance
			)
			||
			null
		);
	}


	/*
	 * -------------------------------------------------------
	 * OFFSET REAL -> OFFSET SIMULADO
	 * -------------------------------------------------------
	 *
	 * Ejemplo:
	 *
	 * offsets reales:
	 *
	 * 0 min
	 * 2 min
	 * 5 min
	 *
	 * se comprimen dentro de la ventana
	 * MAX_START_WINDOW_SECONDS.
	 */
	getSimulationStartSeconds(
		distanceConfig,
		distanceConfigs
	) {

		if (
			!distanceConfig ||
			!distanceConfigs ||
			distanceConfigs.length === 0
		) {

			return 0;
		}


		const offsets =
			distanceConfigs.map(
				(config) =>
					Number(
						config.offset || 0
					)
			);


		const minOffset =
			Math.min(
				...offsets
			);


		const maxOffset =
			Math.max(
				...offsets
			);


		const maxRelativeOffset =
			maxOffset -
				minOffset;


		/*
		 * Todas las largadas tienen
		 * el mismo offset.
		 */
		if (
			maxRelativeOffset <= 0
		) {

			return 0;
		}


		const relativeOffset =
			Math.max(
				0,

				Number(
					distanceConfig.offset || 0
				) -
					minOffset
			);


		return (
			relativeOffset /
				maxRelativeOffset
		) *
			MAX_START_WINDOW_SECONDS;
	}


	generateFinishSeconds(
		startSeconds
	) {

		const availableSeconds =
			MAX_SIMULATION_SECONDS -
				startSeconds;


		if (
			availableSeconds <=
				MIN_RACE_TIME_SECONDS
		) {

			return MAX_SIMULATION_SECONDS;
		}


		const raceTimeSeconds =
			MIN_RACE_TIME_SECONDS +
				Math.random() *
				(
					availableSeconds -
						MIN_RACE_TIME_SECONDS
				);


		return Math.min(
			MAX_SIMULATION_SECONDS,

			startSeconds +
				raceTimeSeconds
		);
	}


	getParticipantIndex(
		simulationAthlete
	) {

		let index = -1;


		if (
			simulationAthlete.id !== undefined &&
			simulationAthlete.id !== null
		) {

			index =
				this.props.participantList.findIndex(
					(participant) =>
						participant.id ===
							simulationAthlete.id
				);
		}


		if (
			index < 0
		) {

			index =
				this.props.participantList.findIndex(
					(participant) =>
						String(
							participant.number
						) ===
							String(
								simulationAthlete.number
							)
				);
		}


		return index;
	}


	/*
	 * -------------------------------------------------------
	 * INICIAR / REINICIAR SIMULACION
	 * -------------------------------------------------------
	 */
	handleSimulation() {

		if (
			this.state.running
		) {

			return;
		}


		if (
			!this.props.startedAt ||
			this.props.startedAt <= 0
		) {

			console.log(
				'Debe iniciar el Timer antes de comenzar la simulación.'
			);

			return;
		}


		/*
		 * Obtenemos las configuraciones de largada.
		 *
		 * Pedestrismo:
		 * por distancia.
		 *
		 * Triatlón / Duatlón / MTB:
		 * por categoría.
		 */
		const distanceConfigs =
			this.getDistanceConfigs();


		if (
			distanceConfigs.length === 0
		) {

			console.log(
				this.usesCategoryStartOffsets()
					? 'No hay categorías configuradas para simular.'
					: 'No hay distancias configuradas.'
			);

			return;
		}


		/*
		 * Si progress === 100 significa que
		 * estamos presionando "Simular nuevamente".
		 */
		const replaceExisting =
			this.state.progress === 100;


		let participantsToSimulate;


		if (
			replaceExisting
		) {

			/*
			 * Segunda simulación:
			 *
			 * tomamos TODOS los atletas válidos,
			 * aunque ya tengan tiempo.
			 */
			participantsToSimulate =
				this.props.participantList.filter(
					(participant) => {

						return (
							Number(
								participant.disqualified || 0
							) === 0
						);
					}
				);


		} else {

			/*
			 * Primera simulación:
			 *
			 * solamente los que todavía
			 * no tienen llegada.
			 */
			participantsToSimulate =
				this.props.participantList.filter(
					(participant) => {

						return (
							Number(
								participant.registeredTime1 || 0
							) === 0
							&&
							Number(
								participant.disqualified || 0
							) === 0
						);
					}
				);
		}


		if (
			participantsToSimulate.length === 0
		) {

			console.log(
				'No hay atletas disponibles para simular.'
			);

			return;
		}


		const simulationAthletes =
			participantsToSimulate

				.map(
					(participant) => {

						const distanceConfig =
							this.getParticipantDistanceConfig(
								participant,
								distanceConfigs
							);


						/*
						 * Si el participante no tiene
						 * una distancia/categoría compatible
						 * no podemos determinar su largada.
						 */
						if (
							!distanceConfig
						) {

							console.warn(
								'Participante sin configuración de largada:',
								participant.number,
								this.usesCategoryStartOffsets()
									? participant.catCod
									: participant.distance
							);

							return null;
						}


						const startSeconds =
							this.getSimulationStartSeconds(
								distanceConfig,
								distanceConfigs
							);


						const finishSeconds =
							this.generateFinishSeconds(
								startSeconds
							);


						return {

							id:
								participant.id,

							number:
								participant.number,

							distance:
								participant.distance,

							catCod:
								participant.catCod,

							catName:
								participant.catName,

							startOffset:
								Number(
									distanceConfig.offset || 0
								),

							startSeconds,

							finishSeconds,

							finishSecond:
								Math.floor(
									finishSeconds
								),

							registered:
								false
						};
					}
				)

				.filter(
					Boolean
				);


		if (
			simulationAthletes.length === 0
		) {

			console.log(
				this.usesCategoryStartOffsets()
					? 'No hay atletas compatibles con las categorías configuradas.'
					: 'No hay atletas compatibles con las distancias configuradas.'
			);

			return;
		}


		simulationAthletes.sort(
			(a, b) =>
				a.finishSeconds -
					b.finishSeconds
		);


		this.simulationStartedAt =
			new Date().getTime();


		this.lastProcessedSecond = -1;


		this.stopSimulationInterval();


		this.setState(
			{
				running:
					true,

				progress:
					0,

				elapsedSeconds:
					0,

				totalAthletes:
					simulationAthletes.length,

				registeredAthletes:
					0,

				simulationAthletes:
					simulationAthletes,

				replaceExisting:
					replaceExisting
			},
			() => {

				this.simulationInterval =
					setInterval(
						this.checkSimulation,
						SIMULATION_INTERVAL_MS
					);
			}
		);
	}


	/*
	 * -------------------------------------------------------
	 * CONTROL DE SIMULACION
	 * -------------------------------------------------------
	 */
	checkSimulation() {

		if (
			!this.state.running ||
			!this.simulationStartedAt
		) {

			return;
		}


		const now =
			new Date().getTime();


		let elapsedSeconds =
			(
				now -
					this.simulationStartedAt
			) /
				1000;


		elapsedSeconds =
			Math.min(
				MAX_SIMULATION_SECONDS,
				elapsedSeconds
			);


		const currentSecond =
			Math.floor(
				elapsedSeconds
			);


		/*
		 * Contador visual.
		 *
		 * Esto NO actualiza Redux.
		 */
		this.setState({
			elapsedSeconds
		});


		/*
		 * Redux máximo una vez por segundo.
		 */
		if (
			currentSecond ===
				this.lastProcessedSecond
		) {

			return;
		}


		this.lastProcessedSecond =
			currentSecond;


		const arrivals = [];


		const updatedAthletes =
			this.state.simulationAthletes.map(
				(simulationAthlete) => {

					if (
						simulationAthlete.registered
					) {

						return simulationAthlete;
					}


					if (
						simulationAthlete.finishSecond >
							currentSecond
					) {

						return simulationAthlete;
					}


					const participantIndex =
						this.getParticipantIndex(
							simulationAthlete
						);


					if (
						participantIndex < 0
					) {

						return simulationAthlete;
					}


					/*
					 * Tiempo neto de carrera
					 * del atleta.
					 *
					 * IMPORTANTE:
					 *
					 * finishSeconds incluye visualmente
					 * el momento de largada.
					 *
					 * Por eso lo restamos para obtener
					 * solamente el tiempo neto.
					 */
					const raceTimeSeconds =
						Math.max(
							0,

							simulationAthlete.finishSeconds -
								simulationAthlete.startSeconds
						);


					/*
					 * El reducer/visualización esperan:
					 *
					 * registeredTime1 - startedAt
					 *
					 * = tiempo neto de carrera.
					 *
					 * El offset no se vuelve a sumar acá.
					 *
					 * Ya fue utilizado para decidir cuándo
					 * comienza visualmente la simulación
					 * del participante.
					 */
					const registeredTime =
						Number(
							this.props.startedAt
						) +
						(
							raceTimeSeconds *
								1000
						);


					arrivals.push({

						index:
							participantIndex,

						now:
							registeredTime
					});


					return {

						...simulationAthlete,

						registered:
							true
					};
				}
			);


		/*
		 * UN SOLO dispatch por segundo.
		 */
		if (
			arrivals.length > 0
		) {

			this.props.registerTimesBatch(
				arrivals,
				this.props.competition,
				this.state.replaceExisting
			);
		}


		const registeredAthletes =
			updatedAthletes.reduce(
				(total, athlete) => {

					return (
						total +
						(
							athlete.registered
								? 1
								: 0
						)
					);
				},
				0
			);


		const totalAthletes =
			updatedAthletes.length;


		const progress =
			totalAthletes > 0
				? Math.round(
					registeredAthletes *
						100 /
						totalAthletes
				)
				: 0;


		const allCompleted =
			registeredAthletes >=
				totalAthletes;


		this.setState(
			{
				registeredAthletes,

				progress:
					allCompleted
						? 100
						: progress,

				simulationAthletes:
					updatedAthletes,

				running:
					!allCompleted
			}
		);


		if (
			allCompleted ||
			currentSecond >=
				MAX_SIMULATION_SECONDS
		) {

			this.stopSimulation();
		}
	}


	stopSimulation() {

		this.stopSimulationInterval();


		this.setState({
			running:
				false,

			progress:
				100,

			elapsedSeconds:
				Math.min(
					MAX_SIMULATION_SECONDS,
					this.state.elapsedSeconds
				)
		});


		console.log(
			'Simulación finalizada.'
		);
	}


	formatSeconds(seconds) {

		const totalSeconds =
			Math.max(
				0,
				Math.floor(
					Number(
						seconds || 0
					)
				)
			);


		const minutes =
			Math.floor(
				totalSeconds /
					60
			);


		const secs =
			totalSeconds %
				60;


		return (
			String(minutes)
				.padStart(
					2,
					'0'
				)
			+
			':' +
			String(secs)
				.padStart(
					2,
					'0'
				)
		);
	}


	render() {

		const elapsed =
			this.formatSeconds(
				this.state.elapsedSeconds
			);


		return (

			<div
				className="container"
			>

				<h3>
					<p align="center">
						<strong>
							Simulaci&oacute;n
						</strong>
					</p>
				</h3>


				<ProgressBar
					bsStyle="success"

					now={
						this.state.progress
					}

					label={
						`${this.state.progress}%`
					}
				/>


				<div
					style={{
						textAlign:
							'center',

						marginBottom:
							'15px'
					}}
				>

					<Button
						bsStyle={
							this.state.running
								? 'success'
								: 'primary'
						}

						disabled={
							this.state.running
						}

						onClick={
							this.handleSimulation
						}
					>

						<Glyphicon
							glyph={
								this.state.running
									? 'time'
									: 'play'
							}
						/>

						{' '}

						{
							this.state.running
								? 'Simulación activa'
								: (
									this.state.progress === 100
										? 'Simular nuevamente'
										: 'Simular'
								)
						}

					</Button>

				</div>


				{
					this.state.running &&
						<div
							style={{
								textAlign:
									'center',

								marginBottom:
									'10px'
							}}
						>

							<strong>
								Tiempo:
							</strong>

							{' '}

							{
								elapsed
							}

							{' / 01:00'}

						</div>
				}


				{
					this.state.totalAthletes > 0 &&
						<div
							style={{
								textAlign:
									'center',

								fontSize:
									'12px',

								color:
									'#666'
							}}
						>

							Llegadas simuladas:

							{' '}

							<strong>
								{
									this.state.registeredAthletes
								}
							</strong>

							{' / '}

							{
								this.state.totalAthletes
							}

						</div>
				}


				<div
					style={{
						marginTop:
							'15px',

						padding:
							'10px',

						background:
							'#f5f5f5',

						border:
							'1px solid #ddd',

						borderRadius:
							'4px',

						fontSize:
							'12px'
					}}
				>

					La simulación dura como máximo
					60 segundos y las llegadas se
					agrupan por segundo.

					{
						this.state.progress === 100 &&
							<span>
								{' '}
								Simular nuevamente generará
								nuevos tiempos para todos
								los atletas.
							</span>
					}

				</div>

			</div>
		);
	}

}


function mapDispatchToProps(
	dispatch
) {

	return bindActionCreators(
		{
			registerTimesBatch
		},
		dispatch
	);
}


function mapStateToProps(
	state
) {

	const {
		participantList
	} =
		state.reducerRegisterTime;


	const {
		startedAt
	} =
		state.reducerTimer;


	const {
		competition,

		distance1Type,
		distance1StartOffset,

		distance2Type,
		distance2StartOffset,

		distance3Type,
		distance3StartOffset,

		categoryStartOffsets

	} =
		state.reducerRegisterInfo;


	return {

		startedAt,

		participantList,

		competition,

		distance1Type,
		distance1StartOffset,

		distance2Type,
		distance2StartOffset,

		distance3Type,
		distance3StartOffset,

		categoryStartOffsets:
			Array.isArray(
				categoryStartOffsets
			)
				? categoryStartOffsets
				: []
	};
}


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	ParticipantRegisterSimulation
);



// WEBPACK FOOTER //
// ./src/containers/participant-list-simulation.js